import {
  TriageToolbarButtonConfig,
  TriageToolbarButtonType,
} from "~/components/TriageToolbar/types";
import { TriageToolbarButton } from "~/components/TriageToolbar/TriageToolbarButton";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  EditOff as EditOffIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import { AttachIcon, DoneIcon } from "~/icons";
import HandymanIcon from "@mui/icons-material/Handyman";
import { JSX } from "react";

const buttonTypes: Record<
  TriageToolbarButtonType,
  (config: TriageToolbarButtonConfig) => JSX.Element
> = {
  [TriageToolbarButtonType.CreateException]: ({
    label = "Set Exception",
    onClick,
    disabled,
    tooltip,
  }) => (
    <TriageToolbarButton
      label={label}
      tooltip={tooltip}
      onClick={onClick}
      data-testid="toolbar-set-exception"
      key="SET_EXCEPTION"
      disabled={disabled}
      icon={<EditIcon sx={{ fontSize: (theme) => theme.spacing(2.25) }} />}
    />
  ),
  [TriageToolbarButtonType.RemoveException]: ({
    label = "Remove Exception and Enable",
    onClick,
    disabled,
    tooltip,
  }) => (
    <TriageToolbarButton
      label={label}
      tooltip={tooltip}
      onClick={onClick}
      data-testid="toolbar-remove-exception"
      key="REMOVE_EXCEPTION"
      disabled={disabled}
      icon={<EditOffIcon sx={{ fontSize: (theme) => theme.spacing(2.25) }} />}
    />
  ),
  [TriageToolbarButtonType.CreateTicket]: ({
    label = "Create Ticket",
    onClick,
    tooltip,
    disabled,
  }) => (
    <TriageToolbarButton
      label={label}
      tooltip={tooltip}
      onClick={onClick}
      data-testid="toolbar-create-case"
      key="REMOVE_EXCEPTION"
      disabled={disabled}
      icon={<AttachIcon sx={{ fontSize: (theme) => theme.spacing(2.25) }} />}
    />
  ),
  [TriageToolbarButtonType.SetOutOfScope]: ({
    label = "Set Out Of Scope",
    onClick,
    disabled,
    tooltip,
  }) => (
    <TriageToolbarButton
      label={label}
      tooltip={tooltip}
      onClick={onClick}
      data-testid="toolbar-set-out-of-scope"
      key="SET_OUT_OF_SCOPE"
      disabled={disabled}
      icon={
        <VisibilityOffIcon sx={{ fontSize: (theme) => theme.spacing(2.25) }} />
      }
    />
  ),
  [TriageToolbarButtonType.SetInScope]: ({
    label = "Set In Scope",
    onClick,
    disabled,
    tooltip,
  }) => (
    <TriageToolbarButton
      label={label}
      tooltip={tooltip}
      onClick={onClick}
      data-testid="toolbar-set-in-scope"
      key="SET_IN_SCOPE"
      disabled={disabled}
      icon={
        <VisibilityIcon sx={{ fontSize: (theme) => theme.spacing(2.25) }} />
      }
    />
  ),
  [TriageToolbarButtonType.Delete]: ({
    label = "Delete",
    onClick,
    disabled,
  }) => (
    <TriageToolbarButton
      label={label}
      onClick={onClick}
      disabled={disabled}
      data-testid="toolbar-delete"
      key="DELETE"
      icon={<DeleteIcon />}
    />
  ),
  [TriageToolbarButtonType.CreateRemediationWorkflow]: ({
    label = "Fix Finding",
    onClick,
    disabled,
    tooltip,
  }) => (
    <TriageToolbarButton
      label={label}
      tooltip={tooltip}
      onClick={onClick}
      data-testid="toolbar-create-remediation-workflow"
      key="CREATE_REMEDIATION_WORKFLOW"
      disabled={disabled}
      icon={<DoneIcon sx={{ fontSize: (theme) => theme.spacing(2.25) }} />}
    />
  ),
};

export const TriageToolbarButtonRenderer = (btn: TriageToolbarButtonConfig) => {
  const ButtonToRender = buttonTypes[btn.type];
  if (!ButtonToRender) return null;

  return ButtonToRender({ ...btn });
};
